export interface RdmInterface {
  id: number;
  description: string;
  label: string;
  parentRefType: string;
  status: string;
  refValue: Object[];
}

export interface RefLang {
  id?: number;
  langCode: string;
  langDescription: string;
}

export interface RefValue {
  id?: number;
  refTypeId: number;
  parentRefValue: number;
  label: string;
  code: string;
  description: string;
  effectiveDateFrom?: Date;
  refLang: RefLang[];
  attributes?:any;
  refValue?: RefValue[];
}

export interface RefValueChild extends RefValue {
  children: RefValue[];
}

export interface RefValueInnerChild extends RefValueChild {
  children: RefValueChild[];
}

export interface RefType {
  id: number;
  label: string;
  description: string;
  status: string;
  parentRefType?:any;
  attributesSchema:[];
  refValue: RefValue[];
}

export interface Sort {
  sorted: boolean;
  unsorted: boolean;
  empty: boolean;
}

export interface Pageable {
  sort?: Sort;
  pageNumber?: number;
  pageSize?: number;
  offset?: number;
  paged?: boolean;
  unpaged?: boolean;
  totalElements?: number;
  totalPages?: number;
}

export interface ReferenceTypeResponse {
  content: RefType[] | RefValue[];
  vehicleContent: RefType[];
  pageable: Pageable;
  totalPages: number;
  totalElements: number;
  last: boolean;
  first: boolean;
  sort: Sort;
  number: number;
  numberOfElements: number;
  size: number;
  empty: boolean;
}

export interface ProductSearchDto {
  content: ProductValue[];
}

export interface StandardPagableResponse {
  content:
    | RefType[]
    | RefValue[]
    | ConsignmentValue[]
    | ProductValue[]
    | ProfileConfig[];
  productSearchDto?: ProductSearchDto;
  vehicleContent: RefType[];
  pageable: Pageable;
  totalPages: number;
  totalElements: number;
  last: boolean;
  first: boolean;
  sort: Sort;
  number: number;
  numberOfElements: number;
  size: number;
  empty: boolean;
}

export interface ConsignmentValue {
  economyID: string;
  economyCode: string;
  economyName: string;
  documentNo: string;
  economyType: string;
  bizCompanyCode: string;
}

export interface ProductValue {
  productCode: string;
  productEngShortDesc?: string;
  tariffCode?: string;
  uom?: string;
}

export interface DeletedAttachmentResponse {
  statusCode: number;
  message: string;
  errorMessage:any;
  content:any;
}

export interface ProfileConfig {
  statusCode: number;
  message: string;
  errorMessage:[];
  content: RiskConfiguration;
}
export interface RiskConfigHistory {
  enableRandomSelectivityFlag?: string;
  intelligenceSupervisorGroupEmail?: string;
  randomSelectivityPercentage?: number;
  riskAnalystGroupEmail?: string;
  updatedDate?: string;
  version?: number;
}

export interface RiskMitigationScoreConfigs {
  departmentCode?: string;
  locationCode?: string;
  locationType?: string;
  mitigationScoreLimit?: number;
  treatmentCode?: string;
  riskMitigationConfigId?: string;
}

export interface LocationBasedConfig {
  globalAutoClearanceLocationId?: Number;
  locationCode?: string;
  locationConfiguration?: Boolean;
}

export interface RiskConfiguration {
  id?: string;
  createdBy?: string;
  createdDate?: string;
  enableRandomSelectivityFlag?: boolean;
  enableGlobalAutoClearance?: boolean;
  autoClearanceTimer: number;
  intelligenceSupervisorGroupEmail?: string;
  randomSelectivityPercentage?: number;
  riskAnalystGroupEmail?: string;
  riskConfigId?: number;
  status?: string;
  updatedBy?: string;
  updatedDate?: string;
  version?: number;
  riskConfigHistory?: RiskConfigHistory[];
  riskMitigationScoreConfigs?: RiskMitigationScoreConfigs[];
  globalAutoClearanceLocations?: LocationBasedConfig[];
  recommendActionConfigs?: Object[];
  aeoConfig?: AeoConfig;
}
 
export interface RecommendedActionCode{
  code:"",
  recomActConfigId?:number,
}

export interface AeoConfig {
  id?: string;
  enableAeoFlag?: boolean;
  riskName?: string;
  riskType?: string;
  riskSubject?: string;
  riskFactorCode?: string;
  // riskOriginCode: string;
  inspectionMethod?: string;
  recommendation?: string;
  createdBy?: string;
  createdDate?: string;
  updatedBy?: string;
  updatedDate?: string;
}
